var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#595959",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1050.386 48l-4.402-4.985 4.402 4.985zm-1.137-11.876c0 4.488-3.637 8.125-8.125 8.125-4.487 0-8.124-3.637-8.124-8.125 0-4.487 3.637-8.124 8.124-8.124 4.488 0 8.125 3.637 8.125 8.124z",
    transform: "translate(-1032 -27)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.4c62f322.svg";
export { ForwardRef as ReactComponent };